<template>
	<div id="subscription_overview" class="container">
		<div class="row">
			<h4 v-if="viewing_user_id !== null" class="text-left col-12">
				<b-alert variant="info" show>
					Member Dashboard: <span v-text="dashboard.user_name"></span>
				</b-alert>
			</h4>
		</div>

		<div>
		</div>

		<div class="card">
			<h4 class="card-header"><span v-text="section_title"></span></h4>

			<div class="">
				<div v-if="page_type === 'success'">

					<b-modal class="modal-xl" size="xl" ref="my-modal" hide-footer title="Welcome to the iAMconncted Platform">
						<div class="d-block text-center">
							<h5>To help you get the most from the platform, please take a moment to watch the video tour below</h5>

							<div class="embed-responsive embed-responsive-16by9">
							<iframe width="560" height="315" src="https://www.youtube.com/embed/ZqUaBS8_bgE" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
					</div>
						<body>If you ever get lost, you can find this video at the bottom of the dashboard</body>
					</div>
						<b-button class="btn-success" block @click="hideModal">Okay, Sign me up!</b-button>
					</b-modal>

					<h5 class="col p-4 text-success">Payment success...</h5>
					<hr />
				</div>
				<!--
				<div v-if="page_type === 'cancelled'">
					<h5 class="col p-4 text-danger">Payment cancelled...</h5>
					<hr />
				</div>
-->

				<b-list-group flush>
					<b-list-group-item v-if="userHasSubscription === 1">
						<div class="row">
							<div class="col-md-3">Current subscription</div>
							<div class="col-md-9">
								<b-list-group
								v-for="subscription in subscription_active"
								:key="subscription.id"
								id="subscriptions"
								>
								<b-list-group-item style="padding:0; border:0">
								<p v-if="subscription.title">
									<b v-text="subscription.title" class="gold"></b>
								</p>
								</b-list-group-item>
								</b-list-group>
								
								<a
									v-if="page_loading === false"
									:href="manageBillingUrl"
									class="btn btn-outline-secondary"
									variant="outline-secondary"
									@click="showLoading()"
									>Manage Subscription & Billing
								</a>
							</div>
						</div>
					</b-list-group-item>

					<b-list-group-item v-if="subscription_options.length > 1">
						<div class="row">
							<div class="col-md-3">Start new subscription</div>
							<div class="col-md-9">
								<b-form-select
									v-if="subscription_options.length > 1"
									v-model="subscription_selected"
									:options="subscription_options"
								></b-form-select>
								<p v-else>
									<i class="fas fa-spinner fa-spin"></i>
									<small> loading products</small>
								</p>

								<stripe-checkout
									ref="checkoutRef"
									:pk="publishableKey"
									:items="subscription_items"
									:successUrl="successUrl"
									:cancelUrl="cancelUrl"
									:sessionId="stripe_session_id"
									:customer="stripe_customer_id"
								>
									<template slot="checkout-button">
										<span v-if="page_loading === true"></span>
										<b-button
											v-else
											variant="outline-primary"
											@click="checkout"
											:disabled="checkoutIsDisabled"
											>Start Subscription
										</b-button>
									</template>
								</stripe-checkout>
							</div>
						</div>
					</b-list-group-item>

					<b-list-group-item v-if="page_loading === true">
						<div class="text-center">
							<p><i class="fas fa-spinner fa-spin"></i></p>
							<p>Loading...</p>
						</div>
					</b-list-group-item>
				</b-list-group>
			</div>
		</div>
	</div>
</template>

<script>
import axios from 'axios';
import { StripeCheckout } from 'vue-stripe-checkout';
export default {
	name: 'SubscriptionOverview',
	components: {
		StripeCheckout,
	},
	data() {
		return {
			checkoutIsDisabled: true,
			customerEmail: this.$store.state.profile.email,
			dasboard: {},
			page_loading: true,
			publishableKey: null,
			//CHANGE THIS STUFF BACK TO LIVE SITE URL
			successUrl: process.env.VUE_APP_SITE_URL + 'payments/subscriptions/success',
			cancelUrl: process.env.VUE_APP_SITE_URL + 'payments/subscriptions/cancelled',
			manageBillingUrl:
				process.env.VUE_APP_API_URL +
				'payments/manage_billing?token=' +
				this.$store.state.session_id,
			new_user: null,
			page_type: this.$route.params.page_type,
			section_title: this.$route.meta.title,
			stripe_session_id: null,
			stripe_customer_id: null,
			subscription_active: {},
			subscription_items: [],
			subscription_options: [{ value: null, text: 'Please select an option' }],
			subscription_selected: null,
			viewing_user_id: null,
			userHasSubscription: null,
			challenges: null,
			challenge_selected: null,
			userSubscribedItems: [],
		};
	},
	computed: {},
	methods: {
		checkout() {
			console.log('checkout:');

			this.showLoading();

			let _this = this;

			let params = new URLSearchParams();
			params.append('token', _this.$store.state.session_id);
			params.append('successUrl', _this.successUrl);
			params.append('cancelUrl', _this.cancelUrl);
			params.append('subscription_selected', _this.subscription_selected);

			if (_this.stripe_customer_id !== null) {
				params.append('customer_id', _this.stripe_customer_id);
			}

			axios({
				url: _this.$store.state.api_url + 'payments/stripeCheckoutSessionCreate',
				params: params,
			})
				.then(function (response) {
					if (
						typeof response.data.result.session !== 'undefined' &&
						response.data.result.session !== null
					) {
						_this.stripe_session_id = response.data.result.session;
						(_this.successUrl =
							//CHANGE THIS STUFF BACK TO LIVE SITE URL
								process.env.VUE_APP_SITE_URL +
							'payments/subscriptions/success?session_id=' +
							_this.stripe_session_id),
							_this.$refs.checkoutRef.redirectToCheckout();
									
					}
				})
				.catch(function (error) {
					console.log(error);
				});
		},

		load_viewing_users_details() {
			let _this = this;

			if (this.viewing_user_id !== null) {
				console.log('load_viewing_users_details:' + this.viewing_user_id);
				_this.dasboard = {};
				let params = new URLSearchParams();
				params.append('token', _this.$store.state.session_id);
				params.append('user_id', _this.viewing_user_id);

				axios({
					url: _this.$store.state.api_url + 'memberGetProfile',
					params: params,
				})
					.then(function (response) {
						if (response.data.profile !== null) {
							console.log('add to dashboard');
							_this.dashboard = response.data.profile;
						}
					})
					.catch(function (error) {
						console.log(error);
					});
			}
		},

		containsObject(obj, list) {
			var i;
			for (i = 0; i < list.length; i++) {
				if (list[i] === obj) {
					return true;
				}
			}

			return false;
		},

		sessionDataGet() {
			console.log('sessionDataGet');
			let _this = this;

			let params = new URLSearchParams();
			params.append('token', _this.$store.state.session_id);

			if (this.$route.query.session_id) {
				params.append('session_id', _this.$route.query.session_id);
			}

			axios({
				url: _this.$store.state.api_url + 'payments/sessionDataGet',
				params: params,
			})
				.then(function (response) {
					if (response.data.result.stripe_public_key) {
						_this.publishableKey = response.data.result.stripe_public_key;
					}

					if (response.data.result.stripe_subscription_plans) {
						const entries = Object.values(response.data.result.stripe_subscription_plans);
						for (const product of entries) {
							if (!_this.containsObject(product.product, _this.userSubscribedItems)) {
								var T = { value: product.id, text: product.title };
								_this.subscription_options.push(T);
								console.log("Pushing: " + T.text);
							}
							
						}
					}

					if (
						response.data.result.stripe_customer_id &&
						response.data.result.stripe_customer_id !== null
					) {
						_this.stripe_customer_id = response.data.result.stripe_customer_id;
					}

					_this.userHasSubscription = response.data.result.userHasSubscription;
					_this.new_user = response.data.result.new_user;
					_this.subscription_active = response.data.result.subscription_active;

					_this.page_loading = false;
					
					_this.challengesGet();	
					for (const challenge of _this.challenges) {
						console.log(challenge);
						if (challenge.subscription === _this.subscription_active[0].product_id) {
							_this.challenge_selected = challenge;
						}
					}	

					if (_this.$route.params.page_type === 'success') {
						console.log("joining challenge: " + _this.challenge_selected);
						_this.challengeJoin(_this.challenge_selected);
						_this.$router.push('/challenges/' + _this.challenge_selected.id);				
					}
			
				})
				.catch(function (error) {
					console.log(error);
				});
		},

		challengesGet() {
			let _this = this;
			let params = new URLSearchParams();
			params.append('token', this.$store.state.session_id);
			axios({
				url: _this.$store.state.api_url + 'challengesGet',
				params: params,
			})
				.then(function (response) {
					if (response.data.status == 1) {
						_this.challenges = Object.values(response.data.challenges);
					} else {
						_this.challenges = null;
					}
					_this.totalRows = _this.challenges.length;
				})
				.catch(function () {
					console.log('Error: challengesGet.');
				});
		},

		challengeJoin(challenge) {
			let _this = this;

			//_this.modal.errors.process = 'Processing...';

			let params = new URLSearchParams();
			params.append('token', _this.$store.state.session_id);
			params.append('status', challenge.status);
			params.append('title', challenge.title);
			params.append('description', challenge.description);
			params.append('video', challenge.video);
			params.append('chat', challenge.chat);
			params.append('subscription', challenge.subscription);
			params.append('id', challenge.id)
			console.log(challenge);

			if (challenge.challenge_leader_selected) {
				const challenge_leader = Object.values(challenge.challenge_leader_selected);
				for (const item of challenge_leader) {
					params.append('challenge_leader[]', item.id);
				}
			}

			if (challenge.challenge_members_selected) {
				const challenge_members = Object.values(challenge.challenge_members_selected);
				for (const item of challenge_members) {
					params.append('challenge_members[]', item.id);
				}
			}
			params.append('challenge_members[]', _this.$store.state.profile.id);

			axios({
				url: _this.$store.state.api_url + 'challengeJoin',
				params: params,
			})
				.then(function (response) {
					//_this.modal.errors.profile = response.data.message;
					if (response.data.status == 1) {
						if (response.data.challenge !== null) {					
							_this.challenges.find((obj) => {
								if (obj.challenge_leader_user_id === challenge.id) {
									obj = response.data.challenge;
								}
							});
						}
						_this.totalRows = _this.challenges.length;
						_this.modal.errors.process = "Success! Challenge updated.";
						_this.challengeView(challenge);

					} else {
						//_this.modal.errors.process = response.data.message;
					}
				})
				.catch(function () {});
		},

		showLoading() {
			this.page_loading = true;
		},

		subscriptionItemSet() {
			this.subscription_items = [
				{
					plan: this.subscription_selected,
					quantity: 1,
				},
			];
		},

		userHasActiveSubscription() {
			console.log('userHasActiveSubscription');
			let _this = this;

			let params = new URLSearchParams();
			params.append('token', _this.$store.state.session_id);

			axios({
				url: _this.$store.state.api_url + 'payments/userHasActiveSubscription_check',
				params: params,
			})
				.then(function (response) {
					_this.userHasSubscription = response.data.status;

					if (response.data.result.subscription) {
						_this.subscription_active.title = response.data.result.subscription.title;
						_this.subscription_active.expires = response.data.result.subscription.expires;
						_this.subscription_active.cost = response.data.result.subscription.cost;
					}
				})
				.catch(function (error) {
					console.log(error);
				});
		},
		showModal() {
        this.$refs['my-modal'].show()
      },
      hideModal() {
        this.$refs['my-modal'].hide()
      },
	},

	created() {},

	mounted() {
		this.sessionDataGet();
		this.challengesGet();
		this.showModal();
	},
	watch: {
		subscription_selected: {
			deep: true,
			immediate: true,
			handler(val) {
				if (val === null) {
					this.checkoutIsDisabled = true;
				} else {
					this.checkoutIsDisabled = false;
					this.subscriptionItemSet();
				}
			},
		},
	},
};
</script>


<style scoped>
	
  .modal-xl {
	width: 1000px !important;
  margin: auto;
  }

  </style>
